import { Pipe, PipeTransform } from '@angular/core';
import { fromNowByUTC } from '../shared/date-time/date.fun';

@Pipe({ name: 'fromNow' })
export class FromNowPipe implements PipeTransform {
  transform(value: string): any {
    return fromNowByUTC(value);
  }
}
